/* eslint-disable no-unused-vars */
import * as dayjs from 'dayjs';
import LinearScale from '../scale/linear';
import { alignBox } from '../utils/boxLayout';
var CordinateCalendar = /** @class */ (function () {
    function CordinateCalendar(option) {
        this.coordinateSystem = 'calendar';
        this.dimensions = ['date'];
        this._option = option;
        this._initCells();
    }
    CordinateCalendar.prototype.getCellSize = function () {
        return this._cellSize;
    };
    CordinateCalendar.prototype.getCells = function () {
        return this._cells;
    };
    CordinateCalendar.prototype.getBoundingRect = function () {
        return this._boundingRect;
    };
    CordinateCalendar.prototype.getWeekScale = function () {
        return this._weekScale;
    };
    CordinateCalendar.prototype.getDayPosition = function (day) {
        return this._dayScale.scale(this._sortedDayList.indexOf(day));
    };
    CordinateCalendar.prototype.dataToPoint = function (data) {
        var date = dayjs(data.date);
        var day = date.day();
        var start = this._weekStart;
        var weekDelta = date.diff(start, 'week');
        return {
            x: this._weekScale.scale(weekDelta),
            y: this.getDayPosition(day),
        };
    };
    CordinateCalendar.prototype.dataToCoord = function (data) {
        return null;
    };
    CordinateCalendar.prototype.coordToPoint = function (coord) {
        return coord;
    };
    CordinateCalendar.prototype.pointToCoord = function (x, y) {
        return { x: x, y: y };
    };
    CordinateCalendar.prototype.coordToData = function () {
        return null;
    };
    CordinateCalendar.prototype.recordToCoord = function (record, dataIndex, encode) {
        return null;
    };
    CordinateCalendar.prototype.recordToPoint = function (record, dataIndex, encode) {
        return null;
    };
    // eslint-disable-next-line no-unused-vars
    CordinateCalendar.prototype.valueToCoord = function (value, dataIndex) {
        return null;
    };
    CordinateCalendar.prototype.getCategoryAxis = function () {
        return null;
    };
    CordinateCalendar.prototype.getValueAxis = function () {
        return null;
    };
    CordinateCalendar.prototype._initCells = function () {
        var _a = this._option, width = _a.width, height = _a.height, startDate = _a.startDate, endDate = _a.endDate, cellSize = _a.cellSize, firstDay = _a.firstDay;
        var start = dayjs(startDate);
        var weekDays = [0, 1, 2, 3, 4, 5, 6];
        if (firstDay < 0 || firstDay > 6) {
            throw new Error('RangeError, calendar firstDay must be in range 0 to 6');
        }
        var sortDayList = weekDays.slice(firstDay).concat(weekDays.slice(0, firstDay));
        var startDayIndex = sortDayList.indexOf(start.day());
        var weekStart = start.add(-startDayIndex, 'day');
        var end = dayjs(endDate);
        var cells = [];
        var date = start;
        this._weekStart = weekStart;
        this._sortedDayList = sortDayList;
        while (!date.isAfter(end)) {
            var week = Math.floor(date.diff(weekStart, 'day') / 7);
            var day = date.day();
            cells.push({
                date: date.format('YYYY-MM-DD'),
                year: date.year(),
                month: date.month(),
                week: week,
                day: day,
                x: 0,
                y: 0,
                next: null,
            });
            date = date.add(1, 'day');
        }
        var weekCount = Math.ceil(end.diff(weekStart.add(-1, 'day'), 'day') / 7);
        var totalWidth = width;
        var totalHeight = height;
        if (cellSize) {
            totalWidth = typeof cellSize[0] === 'number' ? weekCount * cellSize[0] : width;
            totalHeight = typeof cellSize[1] === 'number' ? 7 * cellSize[1] : height;
        }
        var _b = alignBox(this._option, totalWidth, totalHeight, 'center', 'middle'), x = _b.x, y = _b.y;
        var dayScale = new LinearScale(-0.5, 6.5, y, y + totalHeight);
        var weekSacle = new LinearScale(-0.5, weekCount - 0.5, x, x + totalWidth);
        cells.forEach(function (cell, index) {
            cell.x = weekSacle.scale(cell.week);
            cell.y = dayScale.scale(sortDayList.indexOf(cell.day));
            cell.next = cells[index + 1];
        });
        this._cells = cells;
        this._cellSize = [totalWidth / weekCount, totalHeight / 7];
        this._dayScale = dayScale;
        this._weekScale = weekSacle;
        this._boundingRect = { top: y, left: x, right: x + totalWidth, bottom: y + totalHeight };
    };
    return CordinateCalendar;
}());
export default CordinateCalendar;
